"use client";

import React from "react";
import CtaBand from "@/components/common/CtaBand";
import { useLanguage } from "@/hooks/useLanguage";
import { pick, type Lang } from "@/lib/i18n";
interface QuoteBandCopy {
  eyebrow: string;
  heading: string;
  lead: string;
  primaryLabel: string;
  secondaryLabel: string;
}
const copyData: Record<Lang, QuoteBandCopy> = {
  en: {
    eyebrow: "Oil & Gas Separation",
    heading: "Need Engineered Wire Mesh or Custom Filter Assemblies?",
    lead: "Submit your aperture requirements, mesh counts, CAD drawings, or alloy specifications. Our engineering group evaluates fluid dynamics and mechanical constraints to deliver accurate volume quotes.",
    primaryLabel: "Request a Quote",
    secondaryLabel: "Technical Resources"
  },
  zh: {
    eyebrow: "油气分离与过滤",
    heading: "需要定制油气分离丝网或过滤组件？",
    lead: "欢迎提交您的孔径要求、目数规格、CAD 图纸或合金材质要求。工程团队根据流体动力学与机械承压要求为您提供精确的选型与报价方案。",
    primaryLabel: "获取报价",
    secondaryLabel: "技术资料与选型"
  },
  es: {
    eyebrow: "Separación de petróleo y gas",
    heading: "¿Necesita malla metálica técnica o conjuntos filtrantes a medida?",
    lead: "Envíe sus requisitos de abertura, densidades de malla, planos CAD o aleaciones. Nuestro equipo de ingeniería evaluará las restricciones para ofrecer presupuestos precisos.",
    primaryLabel: "Solicitar presupuesto",
    secondaryLabel: "Recursos técnicos"
  },
  de: {
    eyebrow: "Öl- und Gastrennung",
    heading: "Benötigen Sie technische Drahtgewebe oder maßgeschneiderte Filterbaugruppen?",
    lead: "Übermitteln Sie Maschenweiten, Maschenzahlen, CAD-Zeichnungen oder Legierungsvorgaben. Unsere Ingenieure bewerten Strömungsmechanik und Druckgrenzen für ein präzises Angebot.",
    primaryLabel: "Angebot anfragen",
    secondaryLabel: "Technische Ressourcen"
  },
  fr: {
    eyebrow: "Séparation pétrole et gaz",
    heading: "Besoin de toiles métalliques techniques ou d'ensembles filtrants sur mesure ?",
    lead: "Soumettez vos ouvertures de maille, plans CAD ou spécifications d'alliages. Notre équipe d'ingénierie évalue les contraintes pour vous fournir un chiffrage précis.",
    primaryLabel: "Demander un devis",
    secondaryLabel: "Ressources techniques"
  },
  pt: {
    eyebrow: "Separação de óleo e gás",
    heading: "Necessita de telas metálicas técnicas ou montagens filtrantes sob medida?",
    lead: "Envie suas especificações de abertura, malha, desenhos CAD ou ligas metálicas. Nossa equipe de engenharia avalia restrições mecânicas e de fluxo para orçamentos precisos.",
    primaryLabel: "Solicitar orçamento",
    secondaryLabel: "Recursos técnicos"
  }
};
export default function QuoteBand() {
  const {
    lang
  } = useLanguage();
  const content = pick(lang, copyData);
  return <CtaBand id="quoteband" eyebrow={content.eyebrow} heading={content.heading} lead={content.lead} primary={{
    label: content.primaryLabel,
    to: "/RequestAQuotePage"
  }} secondary={{
    label: content.secondaryLabel,
    to: "/TechnicalResourcesPage"
  }} />;
}